import axios from "axios"
export function getScreenLocationsAdmin(token) {
    return axios.get(process.env.REACT_APP_API_URL + `/getScreenLocationsAdmin`, {
        headers: {
            'Authorization': `${token}`
        }
    });
}